import React, { useState, useMemo } from "react";
import useMediaQueries from "hooks/useMediaQueries";
import queryString from "query-string";
import EditEmbedPageDemo from "components/Pages/EditEmbedPage/EditEmbedPageDemo/EditEmbedPageDemo";
import EditEmbedPageContainer from "./EditEmbedPageContent/EditEmbedPageContainer";
import Image from "components/Elements/Image/Image.tsx";
import { useParams, useLocation } from "react-router-dom";
import { useContent } from "contexts/contentContext/contentContext.js";
import { getLocalStorage } from "utils/globalLocalStorage.js";

import "./EditEmbedPage.scss";

const EditEmbedPage = () => {
  const params = useParams();
  const location = useLocation();
  const isAnonymouse = location.search.includes("dem=");
  const demoPageId = isAnonymouse ? queryString.parse(location.search).dem : 0;
  const { newMobileCondition } = useMediaQueries();
  const { getTextByKey } = useContent();
  const [pageMode, setPageMode] = useState("edit");
  const [loading, setLoading] = useState(false);
  const [isFirstTime, setIsFirstTime] = useState(false);

  useMemo(() => {
    const localStorageWelcome = getLocalStorage(
      `welcome-embedpage-${params.EmbedPageUserName}`
    );
    if (!localStorageWelcome) {
      setIsFirstTime(true);
      setPageMode("preview");
    } else {
      setIsFirstTime(false);
    }

    if (isAnonymouse) {
      setPageMode("preview");
    }
  }, []);

  return (
    <div className="embed-page">
      {isAnonymouse ? (
        <EditEmbedPageDemo
          demoPageId={demoPageId}
          isAnonymouse={true}
          loading={loading}
          setLoading={setLoading}
          pageMode={pageMode}
          setPageMode={setPageMode}
          isFirstTime={isFirstTime}
          setIsFirstTime={setIsFirstTime}
        />
      ) : !newMobileCondition ? (
        <EditEmbedPageContainer
          loading={loading}
          setLoading={setLoading}
          pageMode={pageMode}
          setPageMode={setPageMode}
          isFirstTime={isFirstTime}
          setIsFirstTime={setIsFirstTime}
        />
      ) : (
        <div className="empty-personal-page">
          <div className="empty-personal-container">
            <Image name="personal/empty-personal-page" alt="" title="" />
            <h2>{getTextByKey("mobile-error-title")}</h2>
            <p>{getTextByKey("mobile-error-text")}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditEmbedPage;
